export default __webpack_public_path__ + "static/media/GabrielaGonzalez__ponentes.3c84095e.png";